exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mainCardBG{background-color:#f8f9fa}.mdi{margin-left:5px}.table-responsive{max-height:1000px}.table-header{max-width:200px;background-color:#a9e4ce;border:2px solid #d3d3d3;border-bottom-style:none;position:sticky;top:0;font-size:11px}.table-body,.table-header{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.table-background thead{background-color:#a9e4ce;border:2px solid #d3d3d3;border-bottom-style:none;height:40px;position:sticky;top:0;font-size:11px}.my-custom-scrollbar{position:relative;height:550px;overflow:auto}.my-custom-scrollbar_xAxis{position:relative;height:340px;overflow:auto}.table-wrapper-scroll-y{display:block}.md-body-1,.pendencyBody{font-size:11px;font-weight:400;letter-spacing:.01em;line-height:20px}.table-background>tbody{font-size:11px}.table-background>thead{color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48e1d9eb","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/blFreight/blPendencySheet.vue
// module id = 1569
// module chunks = 0